import { IFreeTable } from '@modeso/types__aumico-lib-annualreport-be';
export interface IFreeTableDelegate {
    freeTableComponentData(freeTableData: IFreeTable, componentIndex: number);
}
